import { render, staticRenderFns } from "./Correct.vue?vue&type=template&id=1c639074&scoped=true&"
var script = {}
import style0 from "./Correct.vue?vue&type=style&index=0&id=1c639074&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c639074",
  null
  
)

export default component.exports